module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-textarea', {
    staticClass: "v-static-textarea",
    attrs: {
      "value": _vm.displayText,
      "label": _vm.label,
      "hint": _vm.hint,
      "persistent-hint": _vm.persistentHint,
      "loading": _vm.loading,
      "counter": _vm.counter,
      "rows": _vm.rows,
      "readonly": "",
      "disabled": "",
      "auto-grow": ""
    },
    scopedSlots: _vm._u([{
      key: "progress",
      fn: function() {
        return [_c('v-progress-linear', {
          attrs: {
            "indeterminate": true,
            "color": _vm.progressColor,
            "height": _vm.progressHeight
          }
        })]
      },
      proxy: true
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-664c7e9e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StaticTextArea.vue
// module id = 15
// module chunks = 0